export enum PriorAuthReferralSourceActionDispatchTypes {
  PRIOR_AUTH_REFERRAL_SOURCE_INVOKE = "PRIOR_AUTH_REFERRAL_SOURCE_INVOKE",
  PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS = "PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS",
}
export enum PayerActionDispatchTypes {
    PAYER_INVOKE = "PAYER_INVOKE",
    PAYER_SUCCESS = "PAYER_SUCCESS",
}
export enum IcdCodeTypeActionDispatchTypes {
    ICD_CODE_TYPE_INVOKE = "ICD_CODE_TYPE_INVOKE",
    ICD_CODE_TYPE_SUCCESS = "ICD_CODE_TYPE_SUCCESS",
}

export enum DiseaseTypeActionDispatchTypes {
    DISEASE_TYPE_INVOKE = "DISEASE_TYPE_INVOKE",
    DISEASE_TYPE_SUCCESS = "DISEASE_TYPE_SUCCESS",
}

